import momentTimezone from 'moment-timezone'
// eslint-disable-next-line prettier/prettier
import type { Moment } from 'moment'

import { BUSINESS_TIMEZONE } from 'consts/timezone'

momentTimezone.tz.setDefault(BUSINESS_TIMEZONE)

// Typed as plain moment so @material-ui/pickers / @date-io/moment share the same Moment type.
// Runtime still uses moment-timezone (setDefault above).
const moment = momentTimezone as unknown as typeof import('moment')

export type { Moment }
export default moment
